import React, { Component }from 'react';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {LOGIN_AFFILIATE_GROUP} from '../../configs/staticConfigs';

class NotfoundComponent extends Component {
 
    componentDidMount() {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
    }
    render(){
        return(
            <div className="col-md-12">
                <h1>not found</h1> 
            </div>   
        )
    }

}

export default NotfoundComponent;
